<template>
  <app-header></app-header>
  <div id="app">
    <div>
      <ScaledIframe :src="eventData.eventUrl"></ScaledIframe>
    </div>
    <section class="catalog-detail history-review">
    <div class="info-left">
      <h1 class="title">{{ eventData.title }}</h1>
      <div class="time">
        <p>
          <i class="bi bi-calendar-week"></i>
          <span>{{ eventData.time }}</span>
        </p>
      </div>
      <ul class="options">
        <li v-for="(content, index) in eventInfo" :key="index" @click="scrollToContent(index)">
          {{ content.title }}
        </li>
      </ul>
      <div v-for="(intoContent, index) in eventInfo" :key="index" class="into-list" ref="contentRefs">
        <h2 class="into-title">{{ intoContent.title }}</h2>
        <div v-show="intoContent.content" class="into-content" v-html="intoContent.content"></div>
        <div v-show="intoContent.image" class="into-content" v-html="intoContent.image" @click="planImageClick"></div>
      </div>
    </div>
  </section>
  </div>
  <Loading v-show="loading"></Loading>
  <app-footer></app-footer>
</template>

<script setup>
import AppHeader from '@/components/Header.vue';
import AppFooter from '@/components/Footer.vue';
import Loading from '@/components/Loading.vue';
import ScaledIframe from '@/components/ScaledIframe.vue';
import { ref, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { getWebEvent } from '@/api/eventSerivce';
import { useRouter } from 'vue-router';

const store = useStore();
const router = useRouter();

const eventId = router.currentRoute.value.params.id;
const eventData = ref({});
const eventInfo = ref([]);
const contentRefs = ref([]);
const loading = ref(false);
const isMobile = computed(() => store.state.isMobile);
const currentLanguage = computed(() => store.state.currentLanguage);

const formatTimeRange = (startTime, endTime) => {
  const startDate = new Date(startTime);
  const endDate = new Date(endTime);

  const formatDate = (date) => {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');

    return `${yyyy}/${mm}/${dd}`;
  };

  const formattedStart = formatDate(startDate);
  const formattedEnd = formatDate(endDate);

  return `${formattedStart} ~ ${formattedEnd}`;
};

onMounted(async () => {
  loading.value = true;
  try {
    const langSetting = currentLanguage.value === 'zh_tw' ? 'zh-tw' : currentLanguage.value;
    const res = await getWebEvent(eventId, langSetting);
    const data = res.data.data;

    eventData.value = data;
    eventData.value.time = formatTimeRange(eventData.value.startTime, eventData.value.endTime);
    eventInfo.value = eventData.value.details;
  } catch (error) {
    console.log(error);
    alert('頁面不存在');
    router.push(`/${currentLanguage.value}`);
  } finally {
    loading.value = false;
  }
});

const scrollToContent = (index) => {
  const contentRef = contentRefs.value[index];
  if (contentRef) {
    let offsetTop;
    if (isMobile.value) {
      offsetTop = contentRef.offsetTop - 90;
    } else {
      offsetTop = contentRef.offsetTop - 45;
    }
    window.scrollTo({ top: offsetTop, behavior: 'smooth' });
  }
}
</script>

<style scoped>
@import '../../assets/styles/components/catalog-detail.scss';
.history-review {
  min-height: 70vh;
}
</style>